import { render, staticRenderFns } from "./EmailView.vue?vue&type=template&id=4fe6dbc5&scoped=true"
import script from "./EmailView.ts?vue&type=script&lang=ts&external"
export * from "./EmailView.ts?vue&type=script&lang=ts&external"
import style0 from "./EmailView.scss?vue&type=style&index=0&id=4fe6dbc5&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe6dbc5",
  null
  
)

export default component.exports